/**
 * Format number with minimum one decimal place
 * Examples: 1 -> "1.0", 1.5 -> "1.5", 1.55 -> "1.55", 1.50 -> "1.5"
 */
export const formatMinOneDecimal = (n: number): string => {
  const rounded = Math.round(n * 100) / 100;
  const two = rounded.toFixed(2);
  if (two.endsWith("00")) return rounded.toFixed(1);
  if (two.endsWith("0")) return two.slice(0, -1);
  return two;
};

/**
 * Normalize decimal input value (replace comma with dot, keep only valid chars)
 */
export const normalizeDecimalInput = (
  value: string,
  maxDecimals = 2
): string => {
  let v = value.replace(/,/g, ".");
  v = v.replace(/[^0-9.]/g, "");
  const firstDot = v.indexOf(".");
  if (firstDot !== -1) {
    v = v.slice(0, firstDot + 1) + v.slice(firstDot + 1).replace(/\./g, "");
    if (v.length > firstDot + 1 + maxDecimals) {
      v = v.slice(0, firstDot + 1 + maxDecimals);
    }
  }
  return v;
};

/**
 * Clamp value between min and max
 */
export const clamp = (value: number, min: number, max: number): number => {
  return Math.min(Math.max(value, min), max);
};
